<template>
    <div id="user-list">
      <!-- list filters -->
      <v-card>
        <v-card-text>
          <CRUDTable
            :externalLoading="loading"
            ref="CRUDTable"
            :remoteCreateItem="remoteCreateItem"
            :remoteUpdateItem="remoteUpdateItem"
            :remoteDeleteItem="remoteDeleteItem"
            :remoteGetItem="remoteGetItem"
            :fetchList="fetchList"
            editWith="1000px"
            :searchKeyWord="searchKeyWord"
            :formConfig="formConfig"
            :inputConfigs="inputConfigs"
            @reset="handleReset"
            @openEditDialog="onEditDialog"
          >
          </CRUDTable>
        </v-card-text>
      </v-card>
    </div>
  </template>
  
  <script>
  import { createItem, deleteItem, fetchList, getItem, updateItem } from '@/api/course'
  import CRUDTable from '@/components/CRUD/CRUDTable'
  import { useStore } from '@/store'
  import {
    mdiAccountOutline,
    mdiDeleteOutline,
    mdiDotsVertical,
    mdiExportVariant,
    mdiFileDocumentOutline,
    mdiPlus,
    mdiSquareEditOutline,
  } from '@mdi/js'
  import { ref } from 'vue'
  
  export default {
    components: {
      CRUDTable,
    },
    name : 'Course',
    methods: {
      handleReset() {
        console.log('handleReset')
      },
      onEditDialog(action) {
        console.log('action', action)
      },
    },
    setup() {
      const loading = ref(false)
      const searchKeyWord = ref('')
    //   const store = useStore()
      // let domainUsers = ref([])
      // store
      //   .dispatch('domainUsers/list', {})
      //   .then(result => {
      //     console.log('domainUsers result', result)
      //     domainUsers = result.items
      //   })
      //   .catch(err => {
      //     console.log('err', err)
      //   })
    //   store
    //     .dispatch('organizations/list', {})
    //     .then(result => {
    //       console.log('organizations result', result)
    //       // orgs = result.items
    //     })
    //     .catch(err => {
    //       console.log('err', err)
    //     })
      let formConfig = {
        title: 'Course',
        headers: [
          { value: 'id', text: 'Id' },
          { value: 'courseCode', text: 'CourseCode' },
          { value: 'courseName', text: 'CourseName' },
          { value: 'duration', text: 'Duration(mins)' },
    
          { value: 'actions', text: 'Actions', sortable: false },
        ],
        // customColumns: [
        //   {
        //     name: 'domainUserId',
        //     callback(domainUserId) {
        //       // console.log('in domainUsers callback', domainUsers)
        //       if (domainUsers.length > 0) {
        //         let result = domainUsers.find(domainUser => {
        //           return domainUser.id === domainUserId
        //         })
        //         return result.clientAccount + ' (' + result.orgName + ')'
        //       }
        //       return ''
        //     },
        //   },
        // ],
      }
      return {
        searchKeyWord,
        remoteCreateItem: createItem,
        remoteUpdateItem: updateItem,
        remoteDeleteItem: deleteItem,
        remoteGetItem: getItem,
        fetchList: fetchList,
        icons: {
          mdiSquareEditOutline,
          mdiFileDocumentOutline,
          mdiDotsVertical,
          mdiDeleteOutline,
          mdiPlus,
          mdiExportVariant,
          mdiAccountOutline,
        },
        loading,
        // offsetMd: 6
        inputConfigs: [
        //   { md: 12,  propName: 'id', label: 'Id', readonly: true },
        //   {
        //     md: 6,
        //     propName: 'code',
        //     label: 'Code',
        //     type: {
        //       name: 'select',
        //       storeName: 'orgs',
        //       itemText: 'name',
        //     },
        //   },
          { md: 12, propName: 'courseCode', label: 'CourseCode' },
          { md: 12, propName: 'courseName', label: 'CourseName' },
          { md: 12, propName: 'duration', label: 'Duration' },
        ],
  
        formConfig: formConfig,
      }
    },
  }
  </script>
  
  <style lang="scss">
  @import '@core/preset/preset/apps/user.scss';
  </style>
  